const map = {
    Timestamp: 't',
    'Reservoir Pressure': 'r',
    'Inlet Pressure': 'i',
    'Outlet Pressure': 'o',
    Voltage: 'v',
    Current: 'a',
    T1: 'e',
    T2: 'm',
    'Flow Rate': 'f',
};
export function keyMap(keys) {
    return keys.map((key, index) => {
        const mapped = map[key];
        if (mapped)
            return mapped;
        return String.fromCharCode(65 + index);
    });
}
const units = {
    Timestamp: 'ms',
    'Reservoir Pressure': 'mbar',
    'Inlet Pressure': 'mbar',
    'Outlet Pressure': 'mbar',
    Voltage: 'V',
    Current: 'A',
    T1: 'K',
    T2: 'K',
    'Flow Rate': 'ml/s',
};
export function appendUnits(data) {
    for (const key in data) {
        if (data[key]) {
            const { label } = data[key];
            const unit = units[label] || undefined;
            if (unit)
                data[key].units = unit;
        }
    }
    return data;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTUEsTUFBTSxHQUFHLEdBQTJCO0lBQ2xDLFNBQVMsRUFBRSxHQUFHO0lBQ2Qsb0JBQW9CLEVBQUUsR0FBRztJQUN6QixnQkFBZ0IsRUFBRSxHQUFHO0lBQ3JCLGlCQUFpQixFQUFFLEdBQUc7SUFDdEIsT0FBTyxFQUFFLEdBQUc7SUFDWixPQUFPLEVBQUUsR0FBRztJQUNaLEVBQUUsRUFBRSxHQUFHO0lBQ1AsRUFBRSxFQUFFLEdBQUc7SUFDUCxXQUFXLEVBQUUsR0FBRztDQUNqQixDQUFDO0FBQ0YsTUFBTSxVQUFVLE1BQU0sQ0FBQyxJQUFjO0lBQ25DLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLEdBQUcsRUFBRSxLQUFLLEVBQUUsRUFBRTtRQUM3QixNQUFNLE1BQU0sR0FBRyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDeEIsSUFBSSxNQUFNO1lBQUUsT0FBTyxNQUFNLENBQUM7UUFDMUIsT0FBTyxNQUFNLENBQUMsWUFBWSxDQUFDLEVBQUUsR0FBRyxLQUFLLENBQUMsQ0FBQztJQUN6QyxDQUFDLENBQUMsQ0FBQztBQUNMLENBQUM7QUFFRCxNQUFNLEtBQUssR0FBMkI7SUFDcEMsU0FBUyxFQUFFLElBQUk7SUFDZixvQkFBb0IsRUFBRSxNQUFNO0lBQzVCLGdCQUFnQixFQUFFLE1BQU07SUFDeEIsaUJBQWlCLEVBQUUsTUFBTTtJQUN6QixPQUFPLEVBQUUsR0FBRztJQUNaLE9BQU8sRUFBRSxHQUFHO0lBQ1osRUFBRSxFQUFFLEdBQUc7SUFDUCxFQUFFLEVBQUUsR0FBRztJQUNQLFdBQVcsRUFBRSxNQUFNO0NBQ3BCLENBQUM7QUFDRixNQUFNLFVBQVUsV0FBVyxDQUFDLElBQWdDO0lBQzFELEtBQUssTUFBTSxHQUFHLElBQUksSUFBSSxFQUFFO1FBQ3RCLElBQUksSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFO1lBQ2IsTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztZQUM1QixNQUFNLElBQUksR0FBRyxLQUFLLENBQUMsS0FBSyxDQUFDLElBQUksU0FBUyxDQUFDO1lBQ3ZDLElBQUksSUFBSTtnQkFBRSxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQztTQUNsQztLQUNGO0lBQ0QsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDIn0=